/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelMarketPlan.ts                    *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/market-plan";

export class AutogenModelMarketPlan<RowType extends ModelRow> extends Endpoint<RowType, RowMarketPlanFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowMarketPlan extends ModelRow<RowMarketPlanFields> {
	constructor(values?: Partial<RowMarketPlanFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowMarketPlanFields {
	company_id: string;
	descr: string;
	id: string;
	type_of: string;
}

